import auth from '../authentication';
import Vue from '../main';

export default {
    //Reason Section
    getReason(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/reason-delete/get-all', data)
            .then(response => {
                context.error = false;
                context.reasons = response.data.data;
                context.total = response.data.total;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },

    createReason(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/reason-delete/add-new', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.reason = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    getReasonDetail(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/reason-delete/get-detail/' + id)
            .then(response => {
                context.error = false;
                context.reason = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    updateReason(context, id, data, callback) {
        Vue.http.post(Vue.apiUrl + '/reason-delete/update-detail/' + id, data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.reason = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    removeReason(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/reason-delete/remove/' + id, {})
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                callback(context);
            })
    },
    updateOrder(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/reason-delete/update-order', data)
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
};